import * as Yup from "yup";
import { isString } from "../validations";
import { i18n } from "../i18n";

const schemas = {
    resetPassword: Yup.object({
        email: Yup.string()
            .email(() => i18n.t("validation.resetPassword.email.invalid"))
            .required(() => i18n.t("validation.resetPassword.email.required")),
    }),
    signIn: Yup.object({
        email: Yup.string()
            .email(() => i18n.t("validation.signIn.email.invalid"))
            .required(() => i18n.t("validation.signIn.email.required")),
        password: Yup.string()
            .min(8, () => i18n.t("validation.signIn.password.min"))
            .required(() => i18n.t("validation.signIn.password.required")),
    }),
    profile: Yup.object({
        photoURL: Yup.string().nullable(),
        firstName: Yup.string().required(() => i18n.t("validation.profile.firstName.required")),
        lastName: Yup.string().required(() => i18n.t("validation.profile.lastName.required")),
        email: Yup.string()
            .email(() => i18n.t("validation.profile.email.invalid"))
            .nullable(),
    }),
    changePassword: Yup.object({
        currentPassword: Yup.string().when({
            is: (value: string) => isString(value),
            then: s => s.min(8, () => i18n.t("validation.changePassword.currentPassword.min")),
        }),
        newPassword: Yup.string()
            .when("currentPassword", {
                is: (value: string) => isString(value),
                then: s => s.required(() => i18n.t("validation.changePassword.newPassword.required")),
            })
            .when({
                is: (value: string) => isString(value),
                then: s =>
                    s
                        .min(8, () => i18n.t("validation.changePassword.newPassword.min"))
                        .matches(
                            /^(?=.*[~`!@#$%^&*()-_+={}[\]|\\:;"<>,./?])/,
                            () => i18n.t("validation.changePassword.newPassword.specialCharacter"),
                        )
                        .test(
                            "different-password",
                            () => i18n.t("validation.changePassword.newPassword.different"),
                            function (value) {
                                return value !== this.parent.currentPassword;
                            },
                        ),
            }),
        repeatNewPassword: Yup.string()
            .when("newPassword", {
                is: (value: string) => isString(value),
                then: t => t.required(() => i18n.t("validation.changePassword.repeatNewPassword.required")),
            })
            .test("passwords-match", () => i18n.t("validation.changePassword.repeatNewPassword.match"), function (value) {
                return value === this.parent.newPassword || !this.parent.newPassword;
            }),

        password: Yup.string().when({
            is: (value: string) => isString(value),
            then: s =>
                s
                    .min(8, () => i18n.t("validation.changePassword.password.min"))
                    .matches(
                        /^(?=.*[~`!@#$%^&*()-_+={}[\]|\\:;"<>,./?])/,
                        () => i18n.t("validation.changePassword.password.specialCharacter"),
                    ),
        }),
        repeatPassword: Yup.string()
            .when("password", {
                is: (value: string) => isString(value),
                then: s => s.required(() => i18n.t("validation.changePassword.repeatPassword.required")),
            })
            .test("passwords-match", () => i18n.t("validation.changePassword.repeatPassword.match"), function (value) {
                return value === this.parent.password || !this.parent.password;
            }),
    }),
};

export default schemas;
